import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IFetchParams} from "../utils/get_property_api_params";
import {IOfferDetailPropertiesResponse} from "./fetch_first_properties";

export const fetchAllPropertiesFromOffer = (params: IFetchParams, offer: number | string) => {
    const url = appendQueryString(apiV2ListLink.property.configurator(Scenario.PROPERTY_CONFIGURATOR_LIST), {
        ...params,
        page_size: 10,
        offer
    });

    return getRequest({}, url).then((json: IOfferDetailPropertiesResponse) => {
        return json;
    });
};
import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IFetchParams} from "../utils/get_property_api_params";
import {IOfferDetailPropertiesResponse} from "./fetch_first_properties";

export const fetchAllPropertiesFromOffer = (params: IFetchParams, offer: number | string) => {
    const url = appendQueryString(apiV2ListLink.property.configurator(Scenario.PROPERTY_CONFIGURATOR_LIST), {
        ...params,
        page_size: 10,
        offer
    });

    return getRequest({}, url).then((json: IOfferDetailPropertiesResponse) => {
        return json;
    });
};
